import apiClient from './api';
import { track } from './analytics';

export interface BookmarkDto {
  id: string;
  courseId: number;
  createdAt: string;
}

const bookmarkService = {
  async getBookmarks(): Promise<BookmarkDto[]> {
    try {
      const res = await apiClient.get<BookmarkDto[]>('/api/bookmarks');
      return res.data;
    } catch {
      return [];
    }
  },

  async addBookmark(courseId: number): Promise<BookmarkDto> {
    const res = await apiClient.post<BookmarkDto>(`/api/bookmarks/${courseId}`);
    track('course_bookmarked', { course_id: String(courseId), bookmarked: true });
    return res.data;
  },

  async removeBookmark(courseId: number): Promise<void> {
    await apiClient.delete(`/api/bookmarks/${courseId}`);
    track('course_bookmarked', { course_id: String(courseId), bookmarked: false });
  },
};

export default bookmarkService;
